import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BasicReviewRequestCampaignInfo } from '@models/basicReviewRequestCampaignInfo.model';

@Component({
  selector: 'app-campaign-dropdown',
  templateUrl: './campaign-dropdown.component.html',
  styleUrls: ['./campaign-dropdown.component.sass']
})
export class CampaignDropdownComponent implements OnInit {
  @Input() campaignsBasicInfo: BasicReviewRequestCampaignInfo[];
  @Input() multiSelect: boolean;
  @Output() onSelect = new EventEmitter<string[]>();
  @Input() selectedCampaigns: string[] = [];

  constructor() { }

  ngOnInit(): void {
    
  }

}
